import React from "react";
import Keyword from "./Components/index";
import { fromMonthly, toMonthly } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useFilter from "Hooks/useFilter";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const filter = useFilter();
  const auth = useAuth();

  const { word } = queryString.parse(props.location.search);
  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const activeGroup = auth.state.activeGroup;

  const onClickLineChart = (date) => {
    props.history.push(`/keywords/daily?activeGroup=${activeGroup}&word=${word}&date=${date}`);
  };
  const onClickListButton = (date) => {
    props.history.push(`/keywords/details?activeGroup=${activeGroup}&word=${word}&date=${date}&interval=monthly`);
  };

  return (
    <Keyword
      fromDate={fromDate}
      toDate={toDate}
      word={word}
      target="monthly"
      unit="date"
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
    />
  );
}

export default withRouter(Page);
